import controller from './tunnel.controller';
import templateBase from './templates/tunnel-base.view.html';
import templateT15 from './templates/tunnel-t15.view.html';
import templateAD from './templates/tunnel-view-adaptative.html';

let TunnelComponent = {
    template:changeTemplate ,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if(__env.adaptative){
        return templateAD;
    } else {
        if (response.TUNNEL.component == 'template_t15') { return templateT15; }
        else {
            return templateBase;
        }
    }
}

export default TunnelComponent;


// WEBPACK FOOTER //
// ./www/components/tunnel/tunnel.component.js